<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div
      v-for="(part, index) in form"
      :key="index"
      class="mt-3"
      :class="part.headerClass"
    >
      <div v-if="show(part)">
        <h3 v-if="part.header">
          {{ part.header[$i18n.locale] || part.header }}
        </h3>
        <div
          v-if="part.htmlText"
          v-bind="part"
          v-html="setHtmlText(part.htmlText)"
        />
        <FieldSet
          v-if="part.component === 'FieldSet'"
          :key="`${key}_${part.path}_${Object.keys(part.fields || {}).join(',')}`"
          :values="values"
          :record="record"
          v-bind="part"
          :uuid="uuid"
          :name="part.name"
          :class-name="part.class"
          :group-class="part.groupClass"
          :disabled="disabled || part.disabledOnCorrection === correction"
          :is-current-step="isCurrentStep"
          @input="handleInput"
          @change="$event => $emit('change', $event)"
        />
        <BlockRepeater
          v-if="part.component === 'BlockRepeater'"
          :key="part.path + key"
          v-slot="slotProps"
          :values="values"
          :record="record"
          v-bind="setPart(part)"
          :class-name="part.class"
          :disabled="disabled"
          reverse-order
          @removed="handleRemove({ path: part.path, index: $event.index })"
          @changed="$event => $emit('changed', $event)"
        >
          <FieldSet
            :values="values"
            :record="record"
            v-bind="part"
            :path="`${part.path}.${slotProps.id}`"
            :uuid="uuid"
            :class-name="part.class"
            :group-class="part.groupClass"
            :disabled="disabled"
            :is-current-step="isCurrentStep"
            @input="$event => ($event.index = slotProps.id, handleInput($event))"
          />
        </BlockRepeater>
      </div>
    </div>
  </div>
</template>

<script>
import dot from 'dot-object'
import { evaluateCondition, valuesLookup } from '@/helpers/evaluateCondition'
import FieldSet from '@/components/form/CustomFieldSet.vue'
import BlockRepeater from '@/components/form/BlockRepeater.vue'

export default {
  name: 'DynamicForm',
  components: { FieldSet, BlockRepeater },
  props: {
    form: {
      type: Array,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    record: {
      type: Object,
      default: () => {}
    },
    uuid: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    correction: {
      type: Boolean,
      default: false
    },
    // Whether the step this form belongs to is the process's current step (fields with lockedUnlessCurrentStep are locked otherwise)
    isCurrentStep: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      key: 0
    }
  },
  watch: {
    'values.location.address': {
      deep: true,
      handler (address, oldAddress) {
        if (JSON.stringify(address) !== JSON.stringify(oldAddress)) {
          this.key++
        }
      }
    }
  },
  methods: {
    setHtmlText (html) {
      return html[this.$i18n.locale] || html
    },

    handleRemove ({ path, index }) {
      dot.delete(`${path}[${index}]`, this.values)
      this.$emit('remove', { path, index })
    },

    handleInput ({ value, name, index }) {
      this.$emit('input', { value, name, index })
    },

    setPart (part) {
      part = { ...part }

      if (part.minItemsFrom) {
        const val = dot.pick(part.minItemsFrom, this.values)
        if (val !== undefined) {
          part.minItems = +val
          part.expectedCount = +val
        }
      }

      if (part.note) {
        const text = part.note[this.$i18n.locale] || part.note
        if (typeof text === 'string') {
          const val = part.minItemsFrom ? dot.pick(part.minItemsFrom, this.values) : undefined
          part.note = val !== undefined ? text.replace('{value}', val) : ''
        }
      }

      return part
    },

    show (part) {
      if (part?.htmlText && part.disabledOnCorrection && part.disabledOnCorrection !== this.correction) return false
      if (!part?.showIf) return true
      return evaluateCondition(part.showIf, valuesLookup(this.values, this.record))
    }
  }
}
</script>
